/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { styleSearch } from "./styles";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { defaultCreateValues, typeState } from "./models";
import { useStateValue } from "../../context/store";
import TitleCase from "react-title-case";
import { getActiveRegionals } from "../../actions/regional-actions";
import {
  Button,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  FormHelperText,
  Typography,
  Input,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { REQUIRED_MESSAGE } from "../../constants";
import { TextMaskCustom } from "../../pages/curriculumVitae/help";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { createLaboratory } from "../../actions/laboratory-actions";

const LaboratoryForm = (props) => {
  const { open, setOpen, handleClose, setRefresh, refresh } = props;
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Laboratorio",
      breadCrumbSubText: "Laboratorio",
      index: 22,
      handleSaveOrderClauses: false,
    });
  }, []);

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    oneButtons: false,
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });

  const schema = yup.object().shape({
    laboratoryName: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(100, "Ingrese máximo 100 caracteres")
      .matches(
        /^(([0-9a-zA-ZÑñáéíóúÁÉÍÓÔÚ()/:;.,-_])+[ ]?)*$/,
        "Ingrese un nombre de laboratorio válido"
        ),
    regional: yup.object().nullable().required(REQUIRED_MESSAGE),
    status: yup.string().nullable().required(REQUIRED_MESSAGE),
    email: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .email("Ingrese un correo electrónico válido")
      .min(8, "Ingrese mínimo 8 caracteres")
      .max(80, "Ingrese máximo 80 caracteres"),
    phone: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos")
      .transform((value) =>
        value
          .replace(/\(/g, "")
          .replace(/\)/g, "")
          .replace(/\-/g, "")
          .replace(/\s+/g, "")
      ),
    address: yup
      .string()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(30, "Ingrese máximo 30 caracteres"),
  });

  const { register, handleSubmit, control, errors } = useForm({
    resolver: yupResolver(schema),
    defaultCreateValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [regionales, setRegionales] = useState([]);
  const _ = require("lodash");
  const [{ breadCrumb }, dispatch] = useStateValue();

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const goToLaboratory = () => {
    setMessage({ ...message, open: false });
    handleClickLaboratory();
  };

  const onSubmit = (data) => {
    const newData = {
      laboratoryName: data?.laboratoryName,
      status: data?.status,
      //regionalName: data?.regional?.name,
      regionalId: data?.regional?.id,
      email: data?.email,
      address: data?.address,
      telephone: data.phone
        ?.replace(/\(/g, "")
        ?.replace(/\)/g, "")
        ?.replace(/\-/g, "")
        ?.replace(/\s+/g, ""),
    };
    setMessage({
      description: "¿Está seguro que desea crear Laboratorio?",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClick(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const handleClick = async (data) => {
    setMessage({ ...message, open: false });
    const response = await createLaboratory(data);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setRefresh(!refresh);
      setMessage({
        description: `Laboratorio creado exitosamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => goToLaboratory(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
          ? response?.data?.error
          : `El laboratorio no ha sido creado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleClickLaboratory = () => {
    // props.history.push(`/dashboard/laboratory`)
    setOpen(false);
  };

  const handleCloseForm = () => {
    setOpen(false);
  };

  const handleUserKeyPress = (e) => {
    let invalidChars = ["-", "e", "+", "E", ".", ","];
    if (invalidChars?.includes(e.key)) {
      e.preventDefault();
    }
  };
  const classes = styleSearch();
  return (
    <div>
      <Dialog
        style={{ border: "solid red 1px" }}
        PaperProps={{
          style: { borderRadius: 16, padding: 30, minWidth: "1150px" },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Typography
            style={{
              //paddingTop: "20px",
              textAlign: "center",
              fontSize: "24px",
            }}
          >
            Crear Laboratorio
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <Typography
              style={{
                paddingTop: "20px",
                fontSize: "14px",
                paddingLeft: "50px",
                fontWeight: "bold",
              }}
            >
              Información del laboratorio
            </Typography>
          </DialogContentText>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="off"
          >
            <Grid
              container
              spacing={1}
              style={{ paddingTop: "20px", justifyContent: "space-evenly" }}
            >
              <Grid item xs={12} md={7} lg={7}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    defaultValue=""
                    InputLabelProps={{ shrink: true }}
                    inputRef={register}
                    variant="outlined"
                    className={classes.field}
                    //type="text"
                    autoComplete="off"
                    label="Nombre del laboratorio *"
                    name="laboratoryName"
                    size="small"
                    error={
                      !!errors.hasOwnProperty("laboratoryName") &&
                      errors["laboratoryName"].message
                    }
                    helperText={
                      errors.hasOwnProperty("laboratoryName") &&
                      errors["laboratoryName"].message
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={2} lg={2}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("status") &&
                    errors["status"].message
                  }
                >
                  <InputLabel
                    htmlFor="outlined-select-status"
                    shrink={true}
                    size="small"
                  >
                    Estado *
                  </InputLabel>
                  <Controller
                    fullWidth
                    control={control}
                    inputRef={register}
                    label="Estado"
                    size="small"
                    name="status"
                    notched={true}
                    defaultValue={null}
                    inputProps={{
                      name: "status",
                      id: "outlined-select-status",
                    }}
                    as={
                      <Select>
                        <MenuItem
                          className={classes.menuItem}
                          aria-label="None"
                          value={null}
                        >
                          <em>&nbsp;</em>
                        </MenuItem>
                        {typeState.map((state) => (
                          <MenuItem
                            className={classes.menuItem}
                            key={state}
                            value={state}
                          >
                            <TitleCase string={state} />
                          </MenuItem>
                        ))}
                      </Select>
                    }
                  />
                  <FormHelperText>
                    {errors.hasOwnProperty("status") &&
                      errors["status"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={2} lg={2}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={
                    !!errors.hasOwnProperty("regional") &&
                    errors["regional"].message
                  }
                >
                  <InputLabel
                    htmlFor="outlined-select-regional"
                    shrink={true}
                    size="small"
                  >
                    Regional *
                  </InputLabel>
                  <Controller
                    fullWidth
                    control={control}
                    inputRef={register}
                    label="Regional"
                    size="small"
                    name="regional"
                    notched={true}
                    defaultValue={null}
                    inputProps={{
                      name: "regional",
                      id: "outlined-select-regional",
                    }}
                    as={
                      <Select>
                        <MenuItem
                          className={classes.menuItem}
                          aria-label="None"
                          value={null}
                        >
                          <em>&nbsp;</em>
                        </MenuItem>
                        {regionales.map((op) => (
                          <MenuItem
                            className={classes.menuItem}
                            key={op.id}
                            value={op}
                          >
                            <TitleCase string={op.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    }
                  />
                  <FormHelperText>
                    {errors.hasOwnProperty("regional") &&
                      errors["regional"].message}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{ paddingTop: "10px", justifyContent: "space-evenly" }}
              >
                <Grid item xs={12} md={4} lg={4}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      variant="outlined"
                      inputRef={register}
                      className={classes.field}
                      InputLabelProps={{ shrink: true }}
                      label="Correo electrónico *"
                      placeholder="ejemplo@correo.com"
                      name="email"
                      size="small"
                      error={
                        !!errors.hasOwnProperty("email") &&
                        errors["email"].message
                      }
                      helperText={
                        errors.hasOwnProperty("email") &&
                        errors["email"].message
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4} lg={4}>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      variant="outlined"
                      inputRef={register}
                      className={classes.field}
                      InputLabelProps={{ shrink: true }}
                      label="Dirección *"
                      name="address"
                      size="small"
                      error={
                        !!errors.hasOwnProperty("address") &&
                        errors["address"].message
                      }
                      helperText={
                        errors.hasOwnProperty("address") &&
                        errors["address"].message
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                  <FormControl
                    fullWidth
                    style={{ marginTop: "0px" }}
                    error={
                      !!errors.hasOwnProperty("phone") &&
                      errors["phone"].message
                    }
                  >
                    <InputLabel
                      htmlFor="phone"
                      style={{
                        zIndex: 2,
                        marginTop: "-7px",
                        backgroundColor: "#ffffff",
                        left: "10px",
                      }}
                    >
                      No. Teléfono *
                    </InputLabel>
                    <Input
                      id="phone"
                      disableUnderline
                      inputComponent={TextMaskCustom}
                      variant="outlined"
                      type="text"
                      notched={true}
                      inputRef={register}
                      className={classes.formField}
                      name="phone"
                      style={{ marginTop: "0px" }}
                      inputProps={{
                        style: {
                          height: "18px",
                          borderRadius: "8px",
                          paddingBottom: "0px",
                          fontSize: 14,
                          paddingLeft: "12px",
                        },
                      }}
                      onKeyPress={handleUserKeyPress}
                      size="small"
                    />
                    <FormHelperText style={{ color: "#f44336" }}>
                      {errors.hasOwnProperty("phone") &&
                        errors["phone"].message}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>

              <DialogActions style={{ justifyContent: "space-around" }}>
                <Grid container spacing={1} style={{ paddingTop: "30px" }}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    style={{ textAlign: "center" }}
                  >
                    <Button
                      style={{ color: "#7ebdce" }}
                      variant="contained"
                      className={classes.buttonClear}
                      onClick={() => handleClose()}
                    >
                      Cancelar
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      variant="contained"
                      className={classes.buttonSearch}
                      type="submit"
                    >
                      Guardar
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Grid>
          </form>
        </DialogContent>

        <ModalConfirmBase
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          type={message.type}
          open={message.open}
        />
      </Dialog>
    </div>
  );
};

export default LaboratoryForm;
